import { render, staticRenderFns } from "./ArticleSecond.vue?vue&type=template&id=107e226e&scoped=true"
import script from "./ArticleSecond.vue?vue&type=script&lang=js"
export * from "./ArticleSecond.vue?vue&type=script&lang=js"
import style0 from "./ArticleSecond.vue?vue&type=style&index=0&id=107e226e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107e226e",
  null
  
)

export default component.exports